module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wd-box"
  }, [_c('div', {
    ref: "listContainer",
    staticClass: "wd-box-container",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.data) ? _c('div', {
    staticClass: "wd-user"
  }, [_c('div', {
    staticClass: "wd-user-left"
  }, [_c('img', {
    staticClass: "wd-user-img",
    attrs: {
      "src": _vm.$store.state.userInfo.headPortrait,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wd-user-content"
  }, [_c('span', {
    staticClass: "wd-user-content-span"
  }, [_vm._v(_vm._s(_vm.$store.state.userInfo.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "wd-user-content-span1"
  }, [_vm._v("ID " + _vm._s(_vm.data.recodeCode))])]), _vm._v(" "), _c('div', {
    staticClass: "wd-user-edit",
    on: {
      "click": _vm.handleShowXgzl
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/image/xiugaiziliao@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.xiugaiziliao')))])])]), _vm._v(" "), _c('div', {
    staticClass: "zhibozhongxin",
    on: {
      "click": _vm.handleGoZhibozhongxin
    }
  }, [_vm._v(_vm._s(_vm.$t('all.zhibozhongxin')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wd-zican"
  }, [_c('div', {
    staticClass: "wd-zican-title"
  }, [_c('span', {
    staticClass: "wd-zican-title-span"
  }, [_vm._v(_vm._s(_vm.$t('all.zongzichanguzhi')))]), _vm._v(" "), _c('span', {
    staticClass: "wd-zican-title-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.liushuijilu')))])]), _vm._v(" "), _c('div', {
    staticClass: "wd-zican-box",
    on: {
      "click": _vm.handleGoWallet
    }
  }, [_c('div', {
    staticClass: "wd-zican-box-num"
  }, [_vm._v(_vm._s(_vm.userWalletInfo ? _vm.userWalletInfo.sumAmount : 0))]), _vm._v(" "), _c('div', {
    staticClass: "wd-zican-box-right"
  }, _vm._l((_vm.userWalletInfo.walletList), function(item, index) {
    return _c('div', {
      staticClass: "wd-zican-box-right-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleGoLiushui(item)
        }
      }
    }, [_c('span', {
      staticClass: "wd-zican-box-right-item-span"
    }, [_vm._v(_vm._s(item.currencyName))]), _vm._v(" "), _c('span', {
      staticClass: "wd-zican-box-right-item-span1"
    }, [_vm._v(_vm._s(_vm.$t('all.keyong')) + " " + _vm._s(item.sumAvailableAmount) + " " + _vm._s(_vm.$t('all.dongjie')) + " " + _vm._s(item.sumFreezeAmount))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "wd-num"
  }, [_c('div', {
    staticClass: "wd-chongbi"
  }, [_c('div', {
    staticClass: "wd-chongbi-top"
  }, [_c('div', {
    staticClass: "wd-chongbi-top-left"
  }, [_vm._v(_vm._s(_vm.$t('all.chongbi')))]), _vm._v(" "), _c('div', {
    staticClass: "wd-chongbi-top-right"
  }, _vm._l((_vm.cbList), function(item, index) {
    return _c('div', {
      staticClass: "wd-chongbi-top-right-item"
    }, [_c('span', {
      class: index === _vm.cbListIndex ? 'wd-chongbi-top-right-item-span' : 'wd-chongbi-top-right-item-span1',
      on: {
        "click": function($event) {
          _vm.cbListIndex = index
        }
      }
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), (index == _vm.cbListIndex) ? _c('span', {
      staticClass: "wd-chongbi-top-right-item-xian"
    }) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "wd-chongbi-content"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/image/ewm.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wd-chongbi-content-xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "wd-chongbi-content-right"
  }, [_c('div', {
    staticClass: "wd-chongbi-content-right-item"
  }, [_c('span', {
    staticClass: "wd-chongbi-content-right-item-span"
  }, [_vm._v(_vm._s(_vm.$t('all.wangluo')))]), _vm._v(" "), _c('span', {
    staticClass: "wd-chongbi-content-right-item-span1"
  }, [_vm._v("NB Chain")])]), _vm._v(" "), _c('div', {
    staticClass: "wd-chongbi-content-right-item"
  }, [_c('span', {
    staticClass: "wd-chongbi-content-right-item-span"
  }, [_vm._v(_vm._s(_vm.$t('all.dizhi')))]), _vm._v(" "), _c('span', {
    staticClass: "wd-chongbi-content-right-item-span1"
  }, [_vm._v("0x82...8F91")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "wd-tibi"
  }, [_c('div', {
    staticClass: "wd-chongbi-top"
  }, [_c('div', {
    staticClass: "wd-chongbi-top-left"
  }, [_vm._v(_vm._s(_vm.$t('all.tibi')))]), _vm._v(" "), _c('div', {
    staticClass: "wd-chongbi-top-right"
  }, _vm._l((_vm.tbList), function(item, index) {
    return _c('div', {
      staticClass: "wd-chongbi-top-right-item"
    }, [_c('span', {
      class: index === _vm.tbListIndex ? 'wd-chongbi-top-right-item-span' : 'wd-chongbi-top-right-item-span1',
      on: {
        "click": function($event) {
          _vm.tbListIndex = index
        }
      }
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), (index == _vm.tbListIndex) ? _c('span', {
      staticClass: "wd-chongbi-top-right-item-xian"
    }) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "wd-tibi-dizhi"
  }, [_c('div', {
    staticClass: "wd-tibi-dizhi-item"
  }, [_c('span', {
    staticClass: "wd-tibi-dizhi-item-span"
  }, [_vm._v(_vm._s(_vm.$t('all.dizhi')))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "wd-tibi-dizhi-xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "wd-tibi-dizhi-item"
  }, [_c('span', {
    staticClass: "wd-tibi-dizhi-item-span"
  }, [_vm._v(_vm._s(_vm.$t('all.wangluo')))]), _vm._v(" "), _c('span', {
    staticClass: "wd-tibi-dizhi-item-span1"
  }, [_vm._v("NB Chain")])])]), _vm._v(" "), _c('div', {
    staticClass: "wd-tibi-input-box"
  }, [_c('div', {
    staticClass: "wd-tibi-input"
  }, [_c('div', {
    staticClass: "wd-tibi-input-left"
  }, [_c('span', {
    staticClass: "wd-tibi-input-left-span"
  }, [_vm._v(_vm._s(_vm.$t('all.tibishuliang')))]), _vm._v(" "), _c('span', {
    staticClass: "wd-tibi-input-left-span1"
  }, [_vm._v("(" + _vm._s(_vm.$t('all.zuixiaotibishuliang')) + " 10.00 NB)")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tibiAmount),
      expression: "tibiAmount"
    }],
    staticClass: "wd-tibi-input-input",
    attrs: {
      "type": "text",
      "placeholder": "100.00"
    },
    domProps: {
      "value": (_vm.tibiAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tibiAmount = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wd-tibi-info"
  }, [_c('div', {
    staticClass: "wd-tibi-info-item"
  }, [_c('span', {
    staticClass: "wd-tibi-info-item-span"
  }, [_c('span', {
    staticClass: "wd-tibi-info-item-span-span"
  }, [_vm._v(_vm._s(_vm.$t('all.daozhangshisuan')))]), _vm._v(" "), _c('span', {
    staticClass: "wd-tibi-info-item-span-span1"
  }, [_vm._v("(1%" + _vm._s(_vm.$t('all.shouxufeibilv')) + ")")])]), _vm._v(" "), _c('span', {
    staticClass: "wd-tibi-info-item-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.meirishenyueddu')) + ": 900.00 NB")])]), _vm._v(" "), _c('div', {
    staticClass: "wd-tibi-info-item"
  }, [_c('span', {
    staticClass: "wd-tibi-info-item-span2"
  }, [_vm._v(_vm._s(_vm.$t('all.shouxufei')) + ": "), _c('span', {
    staticClass: "wd-tibi-info-item-highlight"
  }, [_vm._v("1.00NB")])]), _vm._v(" "), _c('span', {
    staticClass: "wd-tibi-info-item-span2"
  }, [_vm._v(_vm._s(_vm.$t('all.meiridaozhang')) + ": "), _c('span', {
    staticClass: "wd-tibi-info-item-highlight1"
  }, [_vm._v("99.00 NB")])])])])])]), _vm._v(" "), _c('duanyingyin', {
    ref: "duanyingyin"
  })], 1), _vm._v(" "), _c('xiaofeimingxi', {
    ref: "xfmx"
  }), _vm._v(" "), _c('xiugaiziliao', {
    ref: "xgzl"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wd-tibi-dizhi-item-right"
  }, [_c('span', {
    staticClass: "wd-tibi-dizhi-item-span1"
  }, [_vm._v("0x82...8F91")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/image/xiayibu_14@2x.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24234428"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/wode/wode.vue
// module id = 955
// module chunks = 1